var _path, _polygon, _path2, _path3, _polygon2, _rect, _path4, _path5, _path6, _g, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClashingEduLogoCurrentColorOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 404 90.3",
    enableBackground: "new 0 0 404 90.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M103.7,54.6c-2.3-2.3-3.5-5.5-3.5-9.5s1.1-7.1,3.4-9.5c2.3-2.3,5.4-3.5,9.3-3.5c3.2,0,5.9,0.9,8.2,2.6 c2.2,1.7,3.6,4.2,4,7.2H118c-0.3-1.2-0.9-2.2-1.8-2.8c-0.9-0.7-2-1-3.3-1c-1.8,0-3.2,0.6-4.1,1.8s-1.4,2.9-1.4,5.2s0.5,4,1.4,5.2 s2.3,1.8,4.1,1.8c1.4,0,2.6-0.4,3.5-1.1c0.9-0.8,1.5-1.8,1.8-3.2h7c-0.4,3.3-1.7,5.8-3.9,7.6c-2.2,1.8-5,2.7-8.3,2.7 C109.1,58.1,106,56.9,103.7,54.6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "134.6,51.4 145.6,51.4 145.6,57.6 127.6,57.6 127.6,32.7 134.6,32.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M165.1,57.6l-1-3.2h-9.7l-1,3.2h-7.1l8.8-24.9h8.4l9.1,24.9H165.1z M156.1,48.6h6l-1.8-5.7 c-0.7-2-1-3.3-1.2-3.9c-0.6,1.9-1,3.2-1.2,3.9L156.1,48.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M174.9,55.8c-1.9-1.6-2.9-3.7-2.9-6.4h6.7c0,1.3,0.4,2.2,1.2,2.7c0.7,0.5,1.9,0.7,3.5,0.7 c2.3,0,3.5-0.7,3.5-2.2c0-0.7-0.3-1.2-0.8-1.5s-1.6-0.6-3.1-0.9l-2-0.3c-5.8-0.9-8.6-3.6-8.6-8c0-2.3,0.9-4.2,2.6-5.6 c1.8-1.4,4.3-2.1,7.6-2.1s5.9,0.7,7.7,2.1c1.8,1.4,2.8,3.4,2.9,6.1h-6.6c0-1-0.4-1.7-1-2.2s-1.6-0.7-2.9-0.7c-2.1,0-3.2,0.7-3.2,2.1 c0,0.7,0.3,1.2,0.8,1.6c0.5,0.3,1.5,0.6,2.8,0.9l2.1,0.3c3.1,0.5,5.4,1.4,6.8,2.6s2.1,2.9,2.1,5.1c0,2.6-1,4.6-2.9,6 s-4.6,2.1-8.1,2.1C179.5,58.1,176.8,57.3,174.9,55.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "211.9,32.7 218.9,32.7 218.9,57.6 211.9,57.6 211.9,48 203.3,48 203.3,57.6 196.4,57.6 196.4,32.7  203.3,32.7 203.3,41.8 211.9,41.8 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 222.4,
    y: 32.7,
    fill: "currentColor",
    width: 7,
    height: 24.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M248.7,32.7h6.6v24.9H248l-5.3-8.8c-1.4-2.4-2.6-4.4-3.4-6.1c0.1,3.4,0.2,7.1,0.2,10.9v4h-6.6V32.7h7.4 l5.3,8.8c1.3,2.1,2.4,4.2,3.4,6.2c-0.1-3.4-0.2-7.1-0.2-11L248.7,32.7L248.7,32.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M271.5,43.3h11.8v14.2h-4.7l-0.7-3.2c-0.8,1.2-1.9,2.2-3.3,2.8c-1.4,0.7-3,1-4.7,1c-3.6,0-6.5-1.2-8.7-3.5 s-3.3-5.5-3.3-9.5s1.1-7.1,3.4-9.5c2.3-2.3,5.4-3.5,9.5-3.5c3.4,0,6.2,0.8,8.3,2.4c2.2,1.6,3.5,3.8,3.9,6.6h-7.1 c-0.7-2-2.4-3.1-5.1-3.1c-1.8,0-3.2,0.6-4.2,1.8s-1.5,3-1.5,5.2s0.5,3.9,1.6,5.2c1.1,1.2,2.6,1.9,4.5,1.9c1.2,0,2.3-0.3,3.2-1 c0.9-0.6,1.5-1.5,1.7-2.6h-4.6L271.5,43.3L271.5,43.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M61.1,45.4L85.3,25C77.9,10.2,62.6,0,44.9,0C20,0-0.2,20.2-0.2,45.1S20,90.3,44.9,90.3 c17.4,0,32.6-9.9,40.1-24.4L61.1,45.4z M31.8,70V20.3l29.3,25L31.8,70z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    d: "M326.9,31.9h20.5v5.4h-13.8v4.5h12.6V47h-12.6v4.9h14.1v5.8h-20.8L326.9,31.9L326.9,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    d: "M351.5,31.9h11.1c7.9,0,12.6,4.8,12.6,12.7c0,8.4-4.8,13-12.6,13h-11.1V31.9z M358.2,51.8h3.2 c5.1-0.1,7.1-2.1,7.1-7.2c0-4.7-2.5-6.9-7.1-6.9h-3.2V51.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef6c00",
    d: "M401.1,46.9c0,7.5-3.4,11.2-11.2,11.2s-11.2-3.7-11.2-11.2v-15h6.7v15.5c0,3.3,1.2,5,4.5,5s4.5-1.7,4.5-5 V31.9h6.7V46.9z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 302.3,
    y: 23.8,
    fill: "#ef6c00",
    width: 6,
    height: 40
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClashingEduLogoCurrentColorOrange);
export default __webpack_public_path__ + "static/media/clashing-edu-logo-currentColor-orange.ff9611b7.svg";
export { ForwardRef as ReactComponent };